import { createSlice } from '@reduxjs/toolkit';
import { fetchWebAssetsList } from '../../api/assetsApi';

const assetsSlice = createSlice({
  name: 'assets',
  initialState: {
    assetLists: {}, // Object to dynamically hold lists for each asset type
    loading: {}, // Tracks loading state for each asset type
    errors: {}, // Tracks errors for each asset type
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle pending state for fetching asset lists
      .addCase(fetchWebAssetsList.pending, (state, action) => {
        const assetKey = action.meta.arg; // The key passed to the thunk
        state.loading[assetKey] = true;
      })
      // Handle fulfilled state for fetching asset lists
      .addCase(fetchWebAssetsList.fulfilled, (state, action) => {
        const {assetKey, data } = action.payload; // The key passed to the thunk
        state.loading[assetKey] = false;
        state.assetLists[assetKey] = data; // Update list for the specific asset key
      })
      // Handle rejected state for fetching asset lists
      .addCase(fetchWebAssetsList.rejected, (state, action) => {
        const assetKey = action.meta.arg; // The key passed to the thunk
        state.loading[assetKey] = false;
        state.errors[assetKey] = action.payload || 'Failed to fetch asset list'; // Store the error
      });
  },
});

export default assetsSlice.reducer;
